export const attraction = {
  attraction: {
    shape: `<path fill="#000" fill-opacity=".51" d="M6.5 17V9h1v8h-1Zm5 0V9h1v8h-1Zm-7.95 3v-1h16.9v1H3.55Zm12.95-3V9h1v8h-1ZM3.55 7v-.85L12 2.125l8.45 4.025V7H3.55Zm2.625-1h11.65L12 3.25 6.175 6Z"/>`,
    viewBox: [0, 0, 24, 24],
  },
};
